<template>
  <div class="changeInfo">
    <el-card>
      <el-form ref="form" label-position="top" :model="form" :rules="rules" label-suffix="：">
        <el-form-item label="现房主姓名">
          <el-input v-model="form.oldNameJm" readonly></el-input>
        </el-form-item>
        <el-form-item label="新房主姓名" prop="name">
          <el-input placeholder="新房主姓名" v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item label="用户地址" prop="address">
          <el-input v-model="form.address" readonly></el-input>
        </el-form-item>
        <el-form-item label="新房主身份证号" prop="idNumber">
          <el-input placeholder="新房主身份证号" v-model.trim="form.idNumber"></el-input>
        </el-form-item>
        <el-form-item label="新房主手机号" prop="mobNo">
          <el-input placeholder="新房主手机号"  v-model.trim="form.mobNo"></el-input>
        </el-form-item>
        <el-form-item prop="captcha" v-if="captchaValidate">
          <el-input v-model.trim="form.captcha" type="text" style="width: 60%" placeholder="验证码"></el-input>
          <button :disabled="disabled" @click="getYzm" type="button" class="yzmBtn" style="width: 38%;">{{msg}}</button>
        </el-form-item>
        <el-form-item label="上传附件">
          <div class="file" v-if="imageId">
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getId"
            />身份证正面
          </div>
          <div v-for="(item,ind) in imgIdList" :key="ind" class="imgDiv">
            <b @click="deleteImgId(ind)" class="el-icon-error error_icon"></b>
            <img class="imgItemRead avatar"   :src="item" alt="">
          </div>
          <div class="file" v-if="imageIdBack">
            <input
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getIdBack"
            />身份证背面
          </div>
          <div v-for="(item,ind) in imgIdBackList" :key="ind" class="imgDiv">
            <b @click="deleteImgIdBack(ind)" class="el-icon-error error_icon"></b>
            <img class="imgItemRead avatar"   :src="item" alt="">
          </div>
          <li>
            <span class="redText" style="font-size: 10px">注意：仅需上传户主信息、房屋信息及签章页</span>
          </li>
          <div class="file">
            <input
              multiple="multiple"
              type="file"
              accept="image/*"
              name="uploader-input"
              class="uploader-file"
              @change="getFile"
            />房产证或购房合同
          </div>
          <div v-for="(item,ind) in imgList" :key=ind class="imgDiv">
            <b @click="deleteImg(ind)" class="el-icon-error error_icon"></b>
            <img class="imgItemRead avatar"   :src="item" alt="">
          </div>
        </el-form-item>
      </el-form>
<!--      <el-button>-->
<!--        <a @click="imghref" :href="imgHref">实名认证</a>-->
<!--      </el-button>-->
      <button @click="changeInfoa" class="btn_bind" style="width: 100%">确认修改</button>
    </el-card>
  </div>
</template>
<script>
  import {getUser, changeInfoName, baidurljc, verifyToken, getCaptcha} from "@/api";
import axios from "@/utils/axios";
  import {isCnNewID, validatePhone} from "@/utils";
export default {
  data() {
    return {
      fileList: [],
      form: {},
      imgList: [],
      imgIdList: [],
      imgIdBackList: [],
      imageId:true,
      imageIdBack:true,
      imagefcz:true,
      ceshi:'',
      imgHref:'',
      accessToken:'',
      msg: '获取验证码',
      disabled: false,
      rules: {
        name: [
          {
            required: true, message: '必填',trigger:'blur'
          }
        ],
        idNumber: [
          {
            required: true, message: '必填',trigger:'blur'
          },
          {validator: isCnNewID,trigger: "blur"}
        ],
        mobNo: [
          {
            required: true, message: '必填',trigger:'blur'
          },
          { validator: validatePhone, trigger: 'blur' }
        ],
      },
      captchaValidate: true
    };
  },
  mounted() {
    this.captchaValidate = JSON.parse(sessionStorage.getItem('roles'))&&JSON.parse(sessionStorage.getItem('roles')).captchaValidate
    this.getDetail();
    this.getBaiduToken();
  },
  methods: {
    getDetail() {
      getUser({
        code: this.$route.query.code,
      }).then((res) => {
        this.form = res.data
        this.form.oldName = res.data.name
        this.form.oldNameJm = this.$formatName(res.data.name)
        this.form.name = ''
        this.form.idNumber = ''
        this.form.mobNo = ''
        this.form.telNo = ''
        // this.$set(this.form,'oldName',res.data.name)
        // this.$set(this.form,'address',res.data.address)
      });
    },
    changeInfoa() {
      //创建formdata对象
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.captchaValidate&&!this.form.captcha) {
            this.$toast('请输入验证码')
            return;
          }
          if(!this.imgIdList.length) {
            this.$toast('请上传身份证正面')
            return;
          }
          if(!this.imgIdBackList.length) {
            this.$toast('请上传身份证背面')
            return;
          }
          if(!this.imgList.length) {
            this.$toast('请上传房产证或购房合同')
            return;
          }
          var formdata = new FormData();
          delete this.form.oldNameJm
          for (let k in this.form) {
            formdata.append(k, this.form[k]);
          }
          this.fileList.map(file=>{
            formdata.append("files", file);
          })

            changeInfoName(formdata).then(res=>{
              if(res) {
                this.$toast('提交成功')
                this.$router.go(-1)
              }
            });

        }
      })
    },
    getFile(e) {
      let fileList = e.target.files
      for(var i=0;i<fileList.length;i++){
        let file=fileList[i];                 /* 获取单个File对象 */
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {    //成功读取文件
          this.imgList.push(e.target.result)
        };
      }
      this.imagefcz = false
    },
    getId(e){
      let file = e.target.files[0]
      this.fileList.push(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload =  (e) => {    //成功读取文件
        this.imgIdList.push(e.target.result)
      };
      this.imageId = false
    },
    getIdBack(e){
      console.log(e)
      let file = e.target.files[0]
      this.fileList.push(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload =  (e) => {    //成功读取文件
        this.imgIdBackList.push(e.target.result)
      };
      this.imageIdBack = false
    },
    deleteImg(ind) {
      this.imgList.splice(ind,1);
      this.fileList.splice(ind,1)
      this.imagefcz = true
    },
    deleteImgId(ind) {
      this.imgIdList.splice(ind,1);
      this.fileList.splice(ind,1)
      this.imageId = true
    },
    deleteImgIdBack(ind) {
      this.imgIdBackList.splice(ind,1);
      this.fileList.splice(ind,1)
      this.imageIdBack = true
    },
    getBaiduToken(){
      verifyToken().then(res => {
        this.accessToken = res.data
        console.log(this.accessToken)
      })
    },
    imghref(){
      this.imgHref = 'https://brain.baidu.com/face/print/'+"?token="+this.accessToken+"&successUrl="+window.location.href+this.$route.path+"?code="+this.$route.query.code+"?userId="+this.$route.query.userId+sessionStorage.setItem('companyCode',sessionStorage.getItem("companyCode"))+"&failedUrl="+window.document.location.href+"?code="+this.$route.query.code+"?userId="+this.$route.query.userId
    },
    getYzm() {
      var reg_tel = /^(1)\d{10}$/;
      if(!reg_tel.test(this.form.mobNo)) {
        this.$toast('请输入正确的手机号码')
        return
      }
      let params = {
        sysType: 0,
        phone: this.form.mobNo,
        companyCode: sessionStorage.getItem('companyCode')
      }
      getCaptcha(params).then(res=>{
        if(res.code=='0000') {
          this.maxtime = 60
          this.disabled = true
          this.timer = setInterval(() => {
            this.CountDown()
          }, 1000)
        }
      })
    },
    CountDown() {
      if (this.maxtime > 0) {
        let seconds = this.maxtime
        this.msg =   + seconds + "s"+'后获取';
        --this.maxtime;
      } else{
        clearInterval(this.timer);
        this.msg = '获取验证码'
        this.disabled = false
      }
    }

  },
};
</script>
<style>
.changeInfo {
  padding: 3%;
  min-height: 90%;
}
.redText {
  color: red;
}
.uploader-file {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.yzmBtn{
  border: 1px solid #C2E7B0;
  border-radius: 3px;
  line-height: 26px;
  background: #F0F9EB;
  color: #67C23A;
  font-size: 12px;
  /*background: #000;*/
}
.uploader-file:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 100%;
  height: 178px;
  display: block;
  margin-top: 25px;
}

.file {
    width: 92%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px  #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
}
.file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
}
.file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
}
.imgDiv{
  position: relative;
}
.error_icon{
  position: absolute;
  font-size: 25px;
  right: -15px;
  top:-18px;
  z-index: 999999;
  color: #f00;
}

</style>



// WEBPACK FOOTER //
// src/view/ywbl/gm/changeInfo.vue